
import { BUSINESS_UNIT_METADATA } from '../../businessunit/model/business-unit.metadata';
import { FIREARM_ASSIGNMENT_METADATA } from '../../firearm_assignment/model/firearm-assignment.metadata';
import { RANGER_METADATA } from '../../ranger/model/ranger.metadata';
import { EntityMetadata, GenericEntityMetadata, PropertyMetadata, RelationshipType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class RangerFirearmAssignmentLogMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('RangerFirearmAssignmentLog', {
      rangerId: <PropertyMetadata> {
        name: 'rangerId',
        type: 'number',
        plural: false,
        isIdentity: true,
        derived: false,
        required: true,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      assignments: <PropertyMetadata> {
        name: 'assignments',
        type: 'FirearmAssignment',
        plural: true,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        relationship: true,
        relationshipType: RelationshipType.OneToMany,
        get relationshipEntityMetadata(): EntityMetadata {
          return FIREARM_ASSIGNMENT_METADATA;
        },
        byReference: true,
        unique: false
      },
      businessUnit: <PropertyMetadata> {
        name: 'businessUnit',
        type: 'BusinessUnit',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: true,
        readable: true,
        writeable: false,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return BUSINESS_UNIT_METADATA;
        },
        byReference: true,
        unique: false
      },
      ranger: <PropertyMetadata> {
        name: 'ranger',
        type: 'Ranger',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return RANGER_METADATA;
        },
        byReference: true,
        unique: false
      },
      currentFirearmCount: <PropertyMetadata> {
        name: 'currentFirearmCount',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      firearmActionPendingCount: <PropertyMetadata> {
        name: 'firearmActionPendingCount',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      rangerActionPendingCount: <PropertyMetadata> {
        name: 'rangerActionPendingCount',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.rangerId;
    return nullIfContainsNull(result);
  }
}



